// Заглушка fs: у браузері jkurwa отримує ключ і сертифікати буферами, а не шляхами
const unavailable = () => { throw new Error("fs недоступний у браузері"); };
export default { readFileSync: unavailable };
export const readFileSync = unavailable;
